import { term } from '../../../../packages/JsonQuery';
import { EFetchMapDataActionType } from '../../../Map/actions';
import { TReduxActions } from '../../actions';
import { EResultsActionType } from '../../actions/results';
import { IResultsState, EResultsStatus } from '../../types/results';

const defaultState: IResultsState = {
  status: EResultsStatus.Initial,
  jsonQuery: {
    _type: 'flatrent',
    engine_version: term(2),
  },
  subdomain: 'www',
};

export function resultsReducer(state: IResultsState = defaultState, action: TReduxActions): IResultsState {
  switch (action.type) {
    case EFetchMapDataActionType.Loading:
      return {
        ...state,
        status: EResultsStatus.Loading,
      };

    case EFetchMapDataActionType.Failed:
      return {
        ...state,
        status: EResultsStatus.Failed,
      };

    case EFetchMapDataActionType.Succeed:
      return {
        ...state,
        status: EResultsStatus.Succeed,
        // @ts-ignore
        jsonQuery: action.payload.jsonQuery,
        version: action.payload.clean ? Symbol() : state.version,
      };

    case EResultsActionType.SetSubdomain:
      return {
        ...state,
        subdomain: action.payload,
      };
  }

  return state;
}
